import React, { useState, useEffect, ReactNode } from "react"
import { FaBars, FaTimes } from "react-icons/fa"

interface NavbarProps {
  title?: string
  hideTitle?: boolean
  links: ReactNode[]
  buttons: ReactNode[]
  logo?: ReactNode
  bgColor?: "gray" | "brand"
}

export const Navbar = ({
  title,
  hideTitle = false,
  links,
  buttons,
  bgColor = "gray",
  logo,
}: NavbarProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  useEffect(() => {
    // Prevent body scroll if mobile menu is open
    if (isMenuOpen) document.body.style.overflow = "hidden"
    else document.body.style.overflow = "unset"

    return () => {
      document.body.style.overflow = "unset"
    }
  }, [isMenuOpen])

  return (
    <>
      {/* desktop nav */}
      <nav
        className={`top-0 z-10 hidden justify-center py-7 md:flex ${
          bgColor === "gray" ? "bg-gray-50" : "bg-brand-100"
        }`}
      >
        <div className="max-w-8xl flex w-full justify-between gap-6 px-5 lg:px-14">
          {/* TODO use Gatsby Link */}
          <a
            href="/"
            className="flex h-12 items-center gap-3 whitespace-nowrap text-lg font-semibold leading-[1.625rem] text-gray-900 antialiased"
          >
            {logo}
            {hideTitle ? null : title}
          </a>
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:gap-14">
            {links}
            {buttons}
          </div>
        </div>
      </nav>
      {/* mobile nav */}
      <nav className="z-10 md:hidden">
        <div
          className={`flex justify-between gap-6 py-3 px-4 ${
            bgColor === "gray" ? "bg-gray-50" : "bg-brand-100"
          }`}
        >
          {/* TODO use Gatsby Link */}
          <a
            href="/"
            className="flex h-8 items-center gap-3 overflow-hidden text-base font-semibold text-gray-900 antialiased"
          >
            {logo && <div className="h-full shrink-0">{logo}</div>}
            {!hideTitle && (
              <span className="overflow-hidden text-ellipsis whitespace-nowrap">
                {title}
              </span>
            )}
          </a>
          <button
            onClick={() => {
              setIsMenuOpen(!isMenuOpen)
            }}
            className="grid h-8 w-8 shrink-0 place-items-center"
            type="button"
          >
            {isMenuOpen ? (
              <FaTimes color="#111827" />
            ) : (
              <FaBars color="#111827" />
            )}
          </button>
        </div>
        {isMenuOpen && (
          <div className="inset-x-0 top-14 bottom-0 z-10 flex h-[calc(100vh-3.5rem)] flex-col gap-14 bg-gray-50 px-5 py-8">
            <div className="flex flex-col gap-8">{links}</div>
            <div className="flex flex-col gap-8">{buttons}</div>
          </div>
        )}
      </nav>
    </>
  )
}
